const units = {
  toast: {
    error: {
      badResponse: '[Unit] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: { default: 'Bereich erfolgreich erstellt' },
      edit: {},
      delete: {
        default: 'Bereiche wurden erfolgreich gelöscht',
      },
    },
  },
  headerButtons: {
    create: 'Erstellen',
    delete: {
      label: 'Löschen',
      deleteModal: {
        header: 'Einheiten löschen',
        body: 'Sie sind dabei, {{units}} Einheiten zu löschen',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Bereich konnte nicht erstellt werden.',
    },
    duplicateToast: {
      message: 'Bereich mit diesem Namen existiert bereits',
    },
    successToast: {
      message: 'Erfolg! Bereich erfolgreich hinzugefügt',
    },
  },

  edit: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Bereich konnte nicht aktualisiert werden.',
    },
    successToast: {
      message: 'Erfolg! Bereich erfolgreich aktualisiert',
    },
  },

  delete: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Bereich konnte nicht gelöscht werden.',
    },
    successToast: {
      message: 'Erfolg! Bereich erfolgreich gelöscht',
    },
    deleteViewSite: {
      message: 'Die Bereichsansicht kann nicht gelöscht werden',
    },
  },

  form: {
    header: {
      create: {
        title: 'Erstellen',
      },

      update: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
        },
      },
      information: {
        header: 'Information',
        fields: {
          operation: {
            title: 'Betrieb',
            options: {
              default: 'Standard',
              school: 'Schule',
              NEMT: 'NEMT',
              microtransit: 'Mikrotransit',
              airportShuttle: 'Flughafenshuttle',
              employee: 'Mitarbeiter',
              deliveries: 'Lieferungen',
              evs: 'Elektrofahrzeuge',
              broker: 'Makler',
            },
          },
          schoolOperationsEnabled: {
            title: 'Schule erlauben',
          },
          employeeOperationsEnabled: {
            title: 'Arbeitsplatz erlauben'
          },
        },
      },
      contactUsInformation: {
        header: 'Mobile App Kontaktinformationen',
        fields: {
          address: 'Adresse',
          phone: 'Telefon',
          email: 'E-Mail',
        },
      },
    },
    valdations: {
      name: {
        required: 'Name ist erforderlich',
        name: 'Ungültiger Name',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      operation: 'Betrieb',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
};

export default units;
